import { Button } from "components/shared/panda/Button"
import { getHref } from "lib/helpers"
import Link from "next/link"
import { IntegrationIcons } from "schemas"
import { Container, HStack, styled, VStack } from "styled-system/jsx"

type Props = IntegrationIcons

function Columns({
  title,
  cta,
  showSalesforce,
  showHubspot,
  showZoho,
  showWebhooks,
}: Props) {
  return (
    <styled.div
      className="integrationIcons"
      css={{
        pt: "60px",
        pb: "72px",
        bgImage:
          "url(/stats-bg.svg), linear-gradient(91deg, #0000CF 0%, #060086 100%)",
        backgroundPosition: "center 65%",
      }}>
      <Container>
        <VStack gap={10}>
          <styled.h1
            css={{
              color: "white",
              textAlign: "center",
              fontFamily: "heading",
              fontSize: "46px",
              fontWeight: "600",
            }}>
            {title}
          </styled.h1>
          <HStack
            gap="9%"
            css={{
              w: "100%",
              maxW: { md: "66%" },

              "& > *": {
                flex: "1 1 auto",
                minW: "0",
              },
            }}>
            {showSalesforce && <img src="/salesforce-logo.png" alt="" />}
            {showHubspot && <img src="/hubspot-logo.png" alt="" />}
            {showZoho && <img src="/zoho-logo.png" alt="" />}
            {showWebhooks && <img src="/webhooks-logo.png" alt="" />}
          </HStack>

          {cta && (
            <Button
              as={Link}
              variant="filled"
              fillColor="tertiary"
              size="medium"
              href={getHref(cta)}>
              {cta.text}
            </Button>
          )}
        </VStack>
      </Container>
    </styled.div>
  )
}

export default Columns
export type { Props as ColumnsProps }
